<template>
  <v-form ref="form" class="">

    <BaseUtil ref="util" :pageLoading="pageLoading" />
    <v-tabs>
      <v-tab>Identificação</v-tab>
      <v-tab>Modal</v-tab>
      <!-- <v-tab>Seguro</v-tab> -->
      <v-tab>Total Manifesto</v-tab>
      <v-tab>Observações</v-tab>
      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="6" md="12">
            <v-autocomplete v-model="entry.taxPayerId" v-bind="getObject('taxPayerId')" label="Emissor"
              :items="extraData.accountContext.allTaxPayers" item-value="id" item-text="text" autocomplete="off"
              @input="retrieveSeriesAndNumberBasedOnTaxPayer" />
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.series" v-bind="getObject('series')" label="Série" :items="seriesList"
              item-value="number" item-text="text" @input="retrieveNumberBasedOnSerieAndTaxPayer"
              :disabled="!entry.taxPayerId" :loading="seriesListLoading" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field v-model="entry.number" v-bind="getObject('number')" label="Número" readonly
              :disabled="!entry.taxPayerId" :loading="numbersListLoading || seriesListLoading" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.modal" v-bind="getObject('modal')" label="Modal"
              :items="extraData.accountContext.allModals" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" clearable @click:clear="$nextTick(() => entry.modal = null)">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.transporterType" v-bind="getObject('transporterType')"
              label="Tipo Transportador" :items="extraData.accountContext.allTransporterTypes" item-value="id"
              item-text="name" :disabled="readOnly" autocomplete="off" clearable
              @click:clear="$nextTick(() => entry.transporterType = null)">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.issuerType" v-bind="getObject('issuerType')" label="Tipo Emitente"
              :items="extraData.accountContext.allIssuerTypes" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" clearable @click:clear="$nextTick(() => entry.issuerType = null)">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12">
            <DateField :inputData.sync="entry.startTravel" v-bind="getObject('startTravel')" label="Data Inicio Viagem"
              :hasTodayButton="true" :hasTodayDate="true" :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="12">
            <v-autocomplete v-model="entry.itemId" v-bind="getObject('itemId')" label="Produto Predominante"
              :items="extraData.accountContext.predominantProducts" item-value="id" item-text="name"
              autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="12">
            <v-autocomplete v-model="entry.loadType" v-bind="getObject('loadType')" label="Tipo de Carga"
              :items="extraData.accountContext.loadTypes" item-value="id" item-text="name" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="12">
            <v-autocomplete v-model="entry.unitTotalWeightCode" v-bind="getObject('unitTotalWeightCode')"
              label="Unidade" :items="extraData.accountContext.unitTotalWeightCodes" item-value="id" item-text="name"
              autocomplete="off" />
          </v-col>


          <v-card class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 card" width="98%"
            title="Carregamento">

            <v-col cols="12" sm="12">
              <div> Cidade de Carregamento </div>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete v-model="entry.loadStateId" label="Estado" :items="extraData.globalContext.allStates"
                item-value="id" item-text="name" @input="stateSelected('load')" autocomplete="new"
                :disabled="readOnly" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete :filter="$customFilter.customFilter" :disabled="entry.loadStateId ? readOnly : true"
                v-model="entry.loadCityId" v-bind="getObject('loadCityId')" label="Cidade" :items="citiesLoadList"
                item-value="id" item-text="name" :loading="citiesListLoading"
                @input="entry.loadCity = citiesLoadList.find(obj => obj.id == entry.loadCityId)" autocomplete="new" />
            </v-col>
          </v-card>


          <br></br>
          <v-card class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 card" width="98%"
            title="Descarregamento">

            <v-col cols="12" sm="12">
              <div> Cidade de Descarregamento </div>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete v-model="entry.unloadStateId" label="Estado" :items="extraData.globalContext.allStates"
                item-value="id" item-text="name" @input="stateSelected('unload')" autocomplete="new"
                :disabled="readOnly" />
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-autocomplete :filter="$customFilter.customFilter" :disabled="entry.unloadStateId ? readOnly : true"
                v-model="entry.unloadCityId" v-bind="getObject('unloadCityId')" label="Cidade" :items="citiesUnloadList"
                item-value="id" item-text="name" :loading="citiesListLoading"
                @input="entry.unloadCity = citiesUnloadList.find(obj => obj.id == entry.unloadCityId)"
                autocomplete="new" />
            </v-col>
          </v-card>

          <!-- <v-col>
            <p>Não informar estados de inicio e fim</p>
          </v-col> -->

          <v-col cols="12" sm="12" v-if="entry.unloadStateId != entry.loadStateId">
            <MultiSelect v-model="entry.stateIds" v-bind="getObject('stateIds')" label="Percurso"
              :items="extraData.globalContext.allStates" itemSubText="additionalInfo"
              itemSecondSubText="secondAdditionalInfo" :loadingItems="stateIdsLoading" :maxLimit="null">
            </MultiSelect>
          </v-col>

        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.carrierId" v-bind="getObject('carrierId')" label="Motorista"
              :items="extraData.accountContext.allDrivers" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" clearable @click:clear="$nextTick(() => entry.carrierId = null)">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.vehicleId" v-bind="getObject('vehicleId')" label="Veículo"
              :items="extraData.accountContext.allTransportVehicles" item-value="id" item-text="vehicleName" :disabled="readOnly" autocomplete="off"
              clearable @click:clear="$nextTick(() => entry.vehicleId = null)">
            </v-autocomplete>
          </v-col>

          <!-- <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.trailerId" v-bind="getObject('trailerId')" label="Reboque"
              :items="extraData.accountContext.allTransportTrailers" item-value="id" item-text="vehicleName" :disabled="readOnly" autocomplete="off"
              clearable @click:clear="$nextTick(() => entry.trailerId = null)">
            </v-autocomplete>
          </v-col> -->


        </v-row>
      </v-tab-item>

      <!-- <v-tab-item>

      </v-tab-item> -->

      <v-tab-item>
        <v-row>

          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="entry.nfeIds.length" label="Nfes" :disabled="true" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="entry.vCarga" label="Valor da carga" :disabled="true" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="entry.qCarga" label="Quantidade da carga" :disabled="true" autocomplete="off" />
          </v-col>

          <!-- <v-col cols="12" sm="12">
            <MultiSelect v-model="entry.nfeIds" v-bind="getObject('nfeIds')" label="NFes" :items="extraData.accountContext.allNfesForMdfe"
            itemSubText="additionalInfo" itemSecondSubText="secondAdditionalInfo" :loadingItems="nfeIdsLoading"
            :maxLimit="null">
          </MultiSelect>
        </v-col> -->
        </v-row>

      </v-tab-item>


      <v-tab-item>
        <v-row>
          <v-col cols="12">
            <v-textarea v-model="entry.observations" label="Observações" outlined></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="entry.fiscoObservations" label="Observações do Fisco" outlined autocomplete="off"></v-textarea>
          </v-col>
        </v-row>
      </v-tab-item>

    </v-tabs>


  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
import BaseUtil from "@shared_components/base_util.vue";
import DateField from "@shared_components/date_field.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import { normalize } from "path";

export default {
  data() {
    return {
      entryAttributes: {},
      seriesList: [],
      numbersListLoading: false,
      seriesListLoading: false,
      pageLoading: false,
      citiesListLoading: false,
      citiesLoadList: [],
      citiesUnloadList: [],
      stateLoadId: null,
      stateUnloadId: null,
      vehiclesListLoading: false,
      vehiclesList: [],
      trailersList: [],
      cashFlowsList: [],
      cashFlowsListLoading: false,
      showExtras: false,
      stateIdsLoading: false,
      nfeIdsLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    printing: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateField: DateField,
    MultiSelect: MultiSelect,
  },
  created() {
    // this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log(this.extraData.globalContext.allStates);
    // console.log("ent", this.entry);
    // console.log("vali", this.entry.validations);
    this.stateSelected("load");
    this.stateSelected("unload");
    if (this.extraData.accountContext.allTaxPayers.length == 1) {
      this.entry.taxPayerId = this.extraData.accountContext.allTaxPayers[0].id;
      this.retrieveSeriesAndNumberBasedOnTaxPayer();
    }
    // console.log("mdfe entry", this.entry);

    if (this.entry.series) {
      this.generateSeriesList(this.entry.series);
    }

    if (this.entry.taxPayerId) {
      this.taxPayerSelected();
    }

    // console.log("nfeIds", this.entry.nfeIds);
  },
  mounted() {
  },
  watch: {
    "entry.cashFlowIdsAttribute": function () {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      // this.selectSale();
    },
  },
  methods: {
    // customFilter: function (itemTitle, queryText, item) {
    //   // console.log(item);
    //   var normalized = item.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
    //   var queryNormalized = queryText.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
    //   var regex = new RegExp(queryNormalized.replaceAll(' ', '.*'));
    //   // console.log(normalized, queryNormalized, regex);
    //   return regex.test(normalized);
    // },
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    activateExtras: function () {
      this.showExtras = !this.showExtras;
    },
    isFormValid: function () {
      // console.log("mdfe form valid called!!!");
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },

    stateSelected: function (type) {
      this.citiesListLoading = true;
      this.$apollo
        .query({
          query: ALL_CITIES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            stateId: type == 'load' ? this.entry.loadStateId : this.entry.unloadStateId,
          }
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          if (type == 'load') {
            this.citiesLoadList = response.data.globalContext.allStateCities;
          } else {
            this.citiesUnloadList = response.data.globalContext.allStateCities;
          }

          // if (this.entry.city) {
          //   this.entry.cityLoadId = this.entry.city.id;
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.citiesListLoading = false));
    },
    taxPayerSelected: function () {
      this.vehiclesListLoading = true;
      this.$apollo
        .query({
          query: ALL_CARRIER_VEHICLES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            taxPayerId: this.entry.taxPayerId,
          }
        })
        .then(response => {
          this.vehiclesList = response.data.accountContext.allCarrierVehicles;
        })
        .catch(response => console.log(response))
        .finally(() => (this.citiesListLoading = false));

      this.vehiclesListLoading = true;

      this.$apollo
        .query({
          query: ALL_CARRIER_TRAILERS_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            taxPayerId: this.entry.taxPayerId,
          }
        })
        .then(response => {
          this.trailersList = response.data.accountContext.allCarrierTrailers;
        })
        .catch(response => console.log(response))
        .finally(() => (this.vehiclesListLoading = false));
    },

    retrieveNumberBasedOnSerieAndTaxPayer: function () {
      // console.log(this.entry.series);
      this.numbersListLoading = true;
      this.$apollo
        .query({
          query: MDFE_NUMBER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            series: this.entry.series,
            taxPayerId: this.entry.taxPayerId
          }
        })
        .then(response => {
          this.entry.number = response.data.accountContext.mdfeNumber;
          // console.log(response.data.accountContext.nfeNumber);
        })
        .catch(response => console.log(response))
        .finally(() => (this.numbersListLoading = false));
    },
    generateSeriesList: function (series) {
      let min;
      let max;
      //CPF (920..969) ou CNPJ (1..889)
      if (series >= 1 && series <= 889) { //CNPJ
        min = 1;
        max = 889;
      } else if (series >= 920 && series <= 969) { //CPF
        min = 920;
        max = 969;
      }

      this.seriesList = [];
      for (let i = min; i <= max; i++) {
        this.seriesList.push({
          number: i,
          text: i
        });
      }
    },
    retrieveSeriesAndNumberBasedOnTaxPayer: function () {
      this.seriesListLoading = true;
      this.$apollo
        .query({
          query: MDFE_SERIES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            taxPayerId: this.entry.taxPayerId
          }
        })
        .then(response => {
          // console.log(response.data.accountContext.nfeSeries);

          this.entry.series = response.data.accountContext.mdfeSeries.series;
          this.entry.number = response.data.accountContext.mdfeSeries.number;
          this.generateSeriesList(this.entry.series);
        })
        .catch(response => console.log(response))
        .finally(() => (this.seriesListLoading = false));

      this.taxPayerSelected();
    },
  }
};

const MDFE_SERIES_QUERY = gql`
  query ($taxPayerId: ID!) {
    accountContext {
      mdfeSeries(taxPayerId: $taxPayerId) {
        series
        number
      }
    }
  }
`;

const MDFE_NUMBER_QUERY = gql`
  query ($series: Int!, $taxPayerId: ID!) {
    accountContext {
      mdfeNumber(series: $series, taxPayerId: $taxPayerId)
    }
  }
`;

const ALL_CITIES_QUERY = gql`
  query ($stateId: ID!) {
    globalContext {
      allStateCities(stateId: $stateId) {
        id
        name
        state {
          id
          name
          shortName
        }
      }
    }
  }
`;

const ALL_CARRIER_VEHICLES_QUERY = gql`
  query ($taxPayerId: ID!) {
    accountContext {
      allCarrierVehicles(taxPayerId: $taxPayerId) {
        id
        vehicleName
      }
    }
  }
`;

const ALL_CARRIER_TRAILERS_QUERY = gql`
  query ($taxPayerId: ID!) {
    accountContext {
      allCarrierTrailers(taxPayerId: $taxPayerId) {
        id
        vehicleName
      }
    }
  }
`;

</script>

<style scoped>
.row {
  margin: 0px;
}

.card {
  margin-bottom: 5px;
}
</style>
